import { createContext, useContext } from 'react';

/** Stores an image file and resolves to the URL a block should point at. */
export type ImageUpload = (file: File) => Promise<string>;

/**
 * The upload the open editor is allowed to perform. Provided by the Editor so
 * the inspector's image fields can offer "Upload image" without importing the
 * HTTP client; absent (undefined) wherever no upload is wired, and those fields
 * stay a plain URL box.
 */
export const ImageUploadContext = createContext<ImageUpload | undefined>(undefined);

/** The editor's image upload, when one is provided. */
export function useImageUpload(): ImageUpload | undefined {
  return useContext(ImageUploadContext);
}
